import validate from "/codebuild/output/src1331441650/src/WDI.Portal/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src1331441650/src/WDI.Portal/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-access": () => import("/codebuild/output/src1331441650/src/WDI.Portal/wdi.portal.client/middleware/admin-access.ts")
}